// src/services/notificationService.ts
import apiClient from './api'

export interface AppNotification {
  id: string
  userId: string
  title: string
  message: string
  // 'outbid' is written straight into the notifications table by the bid path
  // (server/src/models/bidModel.ts inserts type='outbid') and passed through by
  // getUserNotifications, so the client has to model it.
  type: 'info' | 'warning' | 'alert' | 'success' | 'outbid'
  link?: string
  time: string
  read: boolean
  createdAt: string
}

export const notificationService = {
  async getNotifications(): Promise<{ success: boolean; data: AppNotification[]; unreadCount: number }> {
    const res = await apiClient.get<{ success: boolean; data: AppNotification[]; unreadCount: number }>('/api/notifications')
    return res.data
  },

  async markRead(id: string): Promise<{ success: boolean }> {
    const res = await apiClient.put<{ success: boolean }>(`/api/notifications/${id}/read`)
    return res.data
  },

  async markAllRead(): Promise<{ success: boolean }> {
    const res = await apiClient.put<{ success: boolean }>('/api/notifications/read-all')
    return res.data
  },
}

export default notificationService
